<div id="app-frame">
    <div id="app-frame-menu">
        <app-component-nav></app-component-nav>
    </div>

    <div id="app-frame-header">
        <app-component-header></app-component-header>
    </div>

    <div id="app-frame-main">
        <router-outlet></router-outlet>
    </div>

    <div id="app-frame-footer">
        <app-component-footer></app-component-footer>
    </div>
</div>
